import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import searchIcon from "../../../../../assets/img/company/tax-search-icon.svg";
import { i18n } from "../../../private/languageSelector";
import { Field } from "formik";
import { Checkbox } from "@material-ui/core";
import * as serverActions from "../../../../../_redux/products/productsCrud";

export default function TaxSelectionModal({
  show,
  language,
  isFormFilled,
  tax,
  setUnselectedProdCount,
  setProductIds,
  setDefaultProductLoading,
  setShowTaxSelectionModal,
  openTaxesAddDialog,
}) {
  const [products, setProducts] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isApplyButtonClicked, setIsApplyButtonClicked] = useState(false);

  useEffect(() => {
    serverActions.getAllProducts().then((res) => {
      let refactoredProducts = res?.data?.products?.map((item) => {
        return { ...item, name: item?.englishName, selected: tax ? tax?.products?.includes(item?._id) : true };
      });
      setProducts(refactoredProducts);
    });
    //eslint-disable-next-line
  }, []);

  let filteredProducts = products?.filter((item) => {
    let search = searchText?.toLowerCase();
    return item?.name?.toLowerCase().includes(search);
  });

  const applyTaxesOnProduct = () => {
    let filteredProd = filteredProducts?.filter((item) => item?.selected)?.map((item) => item?._id);
    setProductIds(filteredProd);
    setShowTaxSelectionModal(false);
    setIsApplyButtonClicked(true);
  };

  let unSelectedProductCount = products?.filter((item) => !item?.selected)?.length;
  setUnselectedProdCount(unSelectedProductCount);

  const handleBack = () => {
    setProductIds(tax?.products);
    setDefaultProductLoading(true);
    if (!isApplyButtonClicked) {
      let refactoredProducts = products?.map((item) => {
        return { ...item, selected: tax ? tax?.products?.includes(item?._id) : true };
      });
      setProducts(refactoredProducts);
    }
    setShowTaxSelectionModal(false);
  };

  useEffect(() => {
    if (openTaxesAddDialog) {
      setProductIds([...products?.map((item) => item?._id)]);
    }
    //eslint-disable-next-line
  }, [openTaxesAddDialog]);

  return (
    <div>
      <Modal
        className={`${language === "arabic" ? "modal-dialog-arabic modal-drawer" : " modal-drawer"}  my-profile invoice-drawer`}
        size="lg"
        aria-labelledby="example-modal-sizes-title-lg"
        show={show}
        onHide={handleBack}
      >
        <Modal.Header style={{ background: "transparent", direction: language === "arabic" ? "rtl" : "ltr" }}>
          <div className="d-flex justify-content-between align-items-center">
            <span onClick={handleBack} className="cursor-pointer" style={{ color: "#828282", fontWeight: 700 }}>
              {i18n("global.BACK")}
            </span>
            <span
              onClick={applyTaxesOnProduct}
              className="add-edit-tax cursor-pointer"
              style={{
                color: "#2D9CDB",
                opacity: isFormFilled ? 1 : 0.5,
                fontSize: "14px",
                fontWeight: 700,
              }}
            >
              {i18n("global.APPLY")}
            </span>
          </div>
        </Modal.Header>
        <Modal.Body className={`overlay overlay-block cursor-default ${language === "arabic" ? "rtl" : "ltr"}`}>
          <div className={` tax-search-wrap `}>
            <img src={searchIcon} alt="SearchImage" className={`${language === "arabic" ? "mr-3" : "ml-3"}`} />
            <input
              className={`form-control mr-sm-2  ${language === "arabic" ? "mr-1" : "ml-1"}`}
              type="text"
              placeholder={i18n("global.Search")}
              aria-label="Search"
              value={searchText}
              onChange={(e) => setSearchText(e?.target?.value)}
              style={{ background: "transparent" }}
            />
          </div>
          <div className="tax-select-text mt-4">{i18n("global.SelectProductsToApplyTax")}</div>
          <div className="mt-4">
            <Field
              name={"All"}
              component={Checkbox}
              checked={
                products?.filter((item) => item.selected)?.length === products?.length
                  ? true
                  : products?.filter((item) => !item.selected)?.length > 0
                  ? false
                  : true
              }
              onChange={(e) => {
                let checked = e?.target?.checked;
                let allProducts = [...products];
                let prods = allProducts.map((item) => {
                  return { ...item, selected: checked };
                });
                setProducts([...prods]);
              }}
            />
            {i18n("global.All")}
          </div>
          {filteredProducts?.map((item, index) => (
            <div key={index}>
              <div style={{ marginLeft: "1.4rem" }}>
                <Field
                  name={item.name}
                  component={Checkbox}
                  checked={item.selected}
                  disabled={false}
                  onChange={(e) => {
                    let newOption = {
                      ...item,
                      selected: e.target.checked,
                    };
                    products[index] = newOption;
                    setProducts([...products]);
                  }}
                />
                {item.name}
              </div>
            </div>
          ))}
        </Modal.Body>
      </Modal>
    </div>
  );
}
